import React from 'react';
import { ResponsiveContainer, AreaChart, XAxis, CartesianGrid, YAxis, ReferenceDot, Area } from 'recharts';
import { LoadingDataReducerStateType } from '../../reducers/loadingData';
import { getMonitoringStubData, tickFormatter, getTickFormat, getChartStateLabel } from '../../utils/monitoring';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';

const t = i18n(keyset);

interface MonitoringPageChartStubProps {
    fromTs: number;
    toTs: number;
    dataLoadingState: LoadingDataReducerStateType;
    hideXAxis?: boolean;
}

export const MonitoringPageChartStub: React.FC<MonitoringPageChartStubProps> = ({
    fromTs,
    toTs,
    dataLoadingState,
    hideXAxis,
}) => {
    const monitoringStubData = getMonitoringStubData(fromTs, toTs);
    const middle = monitoringStubData[Math.ceil(monitoringStubData.length / 2)];

    return (
        <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={monitoringStubData} style={{ pointerEvents: 'none' }}>
                <XAxis
                    dataKey="x"
                    tickFormatter={(tick) => (hideXAxis ? '' : tickFormatter(tick, getTickFormat(fromTs, toTs)))}
                    minTickGap={50}
                />
                <YAxis dataKey="y" type="number" />
                <CartesianGrid strokeDasharray="3 3" />
                <ReferenceDot
                    x={middle.x}
                    y={middle.y}
                    label={
                        getChartStateLabel(dataLoadingState as any) ||
                        ({ value: t('chart-error-no-data'), fontSize: 13 } as any)
                    }
                    strokeWidth={0}
                />
                <Area dataKey="y" hide />
            </AreaChart>
        </ResponsiveContainer>
    );
};
